<template>
    <div>
        <el-table class="mt-20" :data="filteredItems" v-loading="loading">
            <el-table-column prop="id" label="Order #" sortable>
                <template slot-scope="{ row }">
                    {{ row.id }}
                </template>
            </el-table-column>
            <el-table-column label="Customer" prop="tenant.name" sortable />
            <el-table-column prop="created_at" label="Order Placed" sortable>
                <template slot-scope="scope">
                    {{ scope.row.created_at | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column label="Issue" prop="formatted_month" sortable />
            <el-table-column prop="detailed_status" label="Status" sortable>
                <template slot-scope="scope">
                    <span
                        :class="`${scope.row.detailed_status
                            .replace(/\s+/g, '-')
                            .toLowerCase()}-status`"
                        >{{ scope.row.detailed_status }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="290px">
                <template slot-scope="{ row }">
                    <el-button-group>
                        <el-button
                            @click="downloadItem(row)"
                            icon="mdi mdi-download"
                            size="small"
                            type="primary"
                            v-if="
                                !$store.state.config.settings
                                    .disable_order_download
                            "
                        >
                            Download Files
                        </el-button>
                        <el-button
                            icon="mdi mdi-eye"
                            size="small"
                            type="success"
                            @click="viewItem(row)"
                            >View
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            title=""
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px"
        >
            <order-summary :order="viewingOrder" v-if="viewingOrder" />
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Close</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as ApprovalStatus from "../../../../constants/approval-status";
import OrderSummary from "@/views/pages/order/Summary";

export default {
    props: {
        filter: {
            type: Object,
            default() {
                return {
                    search: null,
                };
            },
        },
    },
    components: {
        OrderSummary,
    },
    data() {
        return {
            ApprovalStatus,
            orders: [],
            loading: false,
            dialogVisible: false,
            viewingOrder: null,
        };
    },
    created() {
        this.getData();
    },
    computed: {
        filteredItems() {
            let items = this.orders;
            if (!Utils.emptyOrNull(this.filter.search)) {
                items = items.filter((item) => {
                    return (
                        item.id == this.filter.search ||
                        _.get(item, "community.name", "")
                            .toLowerCase()
                            .includes(this.filter.search)
                    );
                });
            }
            return items;
        },
    },
    methods: {
        getData() {
            this.loading = true;
            axios
                .get(`/web-api/order`, {
                    params: {
                        pending: 1,
                        all: 1,
                        include: this.$store.state.orders.meta.include,
                    },
                })
                .then((response) => {
                    this.orders = response.data.data;
                })
                .finally(() => (this.loading = false));
        },
        viewItem(order) {
            this.viewingOrder = order;
            this.dialogVisible = true;
        },
        downloadItem(order) {
            window.open(
                `/web-api/order/${order.id}/download-orderable`,
                "_blank"
            );
        },
    },
};
</script>

<style scoped>
.printed-status {
    color: #606266;
}
.designed-status {
    color: #86b142;
}
.printing-status {
    color: #1c41c9;
}
.pdf-emailed-status {
    color: #d34ad5;
}
.proofed-status {
    color: #6385d8;
}
.pdf-approved-status {
    color: #c2111b;
}
</style>
